import { useCallback, useState } from 'react';

const storageKey = (employeeId: number | undefined) => `invoice-comments-hide-handled-${employeeId ?? ''}`;

/** The user's Hide handled choice, kept per employee in localStorage; off when storage is unavailable. */
export function useHideHandled(employeeId: number | undefined): [boolean, (hide: boolean) => void] {
    const [hide, setHide] = useState(() => {
        try {
            return window.localStorage.getItem(storageKey(employeeId)) === 'true';
        } catch {
            return false;
        }
    });
    const remember = useCallback(
        (next: boolean) => {
            setHide(next);
            try {
                window.localStorage.setItem(storageKey(employeeId), String(next));
            } catch {
                // Without storage the choice lasts until the view closes.
            }
        },
        [employeeId]
    );
    return [hide, remember];
}
